<template>
    <div @mousemove="idleReset" @click="idleReset" @mousedown="idleReset" @scroll="idleReset" @keypress="idleReset"
        @load="idleReset">
        <div class="fullscreen-wrapper">
            <div class="topbar">
                <nav
                    class="relative w-full flex flex-wrap items-center justify-between py-3 bg-gray-100 text-gray-500 hover:text-gray-700 focus:text-gray-700 shadow-lg navbar navbar-expand-lg navbar-light">
                    <div class="container-fluid w-full flex flex-wrap items-center justify-between px-6"><button
                            class="navbar-toggler text-gray-500 border-0 hover:shadow-none hover:no-underline py-2 px-2.5 bg-transparent focus:outline-none focus:ring-0 focus:shadow-none focus:no-underline"
                            type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent" aria-expanded="false"
                            aria-label="Toggle navigation"><svg aria-hidden="true" focusable="false" data-prefix="fas"
                                data-icon="bars" class="w-6" role="img" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512">
                                <path fill="currentColor"
                                    d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z">
                                </path>
                            </svg></button>
                        <div class="collapse navbar-collapse flex-grow items-center" id="navbarSupportedContent"><a
                                class="flex items-center text-gray-900 hover:text-gray-900 focus:text-gray-900 mt-2 lg:mt-0 mr-1"
                                href="#"><img src="https://mdbootstrap.com/img/logo/mdb-transaprent-noshadows.png"
                                    style="height:15px" alt="" loading="lazy"></a>
                            <ul class="navbar-nav flex flex-col pl-0 list-style-none mr-auto"></ul>
                        </div>
                        <div class="flex items-center relative">
                            <div class="timer">Session : {{ sessionTime }}</div>
                            <div class="dropdown relative">
                                <a class="dropdown-toggle flex items-center hidden-arrow"
                                    href="#" id="dropdownMenuButton2" role="button" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <profile-img />&nbsp; {{ auth.user.name }}
                                </a>
                                <ul class="dropdown-menu min-w-max absolute bg-white text-base z-50 float-left py-2 list-none text-left rounded-lg shadow-lg mt-3 hidden m-0 bg-clip-padding border-none left-auto right-0"
                                    aria-labelledby="dropdownMenuButton2">
                                    <li>
                                        <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" :href="`/backend/users/${auth.user.id}/edit`">Profile</Link>
                                    </li>
                                    <li>
                                        <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" :href="`/backend/users/${auth.user.id}/password`">Update Password</Link>
                                    </li>
                                    <li>
                                        <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" href="/backend/logout" method="delete" as="button">Logout</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
            <div class="content-page">
                <main-menu class="" />
                <div class="content">
                    <flash-messages />
                    <slot/>
                </div>
            </div>
        </div>

        <!-- <Autologout/> -->
    </div>

</template>

<script>
import axios from 'axios';
import { Link } from '@inertiajs/inertia-vue3';
import MainMenu from '@/Shared/MainMenu';
import FlashMessages from '@/Shared/FlashMessages';
import ProfileImg from '@/Shared/ProfileImg';

export default {
    components: {
        FlashMessages,
        Link,
        MainMenu,
        ProfileImg,
    },
    props: {
        auth: Object,
    },
    data() {
        return {
            idleTime: 600,
            idleCountdown: null,
            idleTimeout: false,
            UITime: 120,
            UICountdown: null,
            UITimeout: false,
            setIdleTimer: null,
            setUITimer: null,
        };
    },
    computed: {
        sessionTime() {
            const d = Number(this.idleCountdown);
            const h = Math.floor(d / 3600);
            const m = Math.floor((d % 3600) / 60);
            const s = Math.floor((d % 3600) % 60);
            const hDisplay = h > 0 ? `${h} h, ` : '';
            const mDisplay = m > 0 ? `${m} m, ` : '';
            const sDisplay = s > 0 ? `${s} s` : '';
            return hDisplay + mDisplay + sDisplay;
        },
    },
    methods: {
        startIdleCountdown() {
            this.idleCountdown = this.idleTime;
            this.setIdleTimer = setInterval(this.idleTimer, 500);
        },
        idleTimer() {
            this.idleCountdown -= 1;
            if (this.idleCountdown <= 0) {
                clearInterval(this.setIdleTimer);
                this.idleTimeout = true;
                this.startUICountdown();
            }
        },
        idleReset() {
            if (!this.idleTimeout) {
                clearInterval(this.setIdleTimer);
                this.startIdleCountdown();
            }
        },
        startUICountdown() {
            this.$swal({
                title: 'Your session is about to expire!',
                text: 'Your session will expire in 1 minute, you can continue or end your session',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#02a11f',
                cancelButtonColor: '#de0202',
                confirmButtonText: 'Continue',
                cancelButtonText: 'End',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.idleReset();
                    location.reload();
                } else {
                    axios.delete('/backend/logout');
                    location.reload();
                }
            });
            this.UICountdown = this.UITime;
            this.setUITimer = setInterval(this.UITimer, 500);
        },
        UITimer() {
            this.UICountdown -= 1;
            if (this.UICountdown <= 0) {
                clearInterval(this.setUITimer);
                this.UITimeout = true;
                this.countdownExpired();
            }
        },
        UIReset() {
            clearInterval(this.setUITimer);
            this.idleTimeout = false;
            this.startIdleCountdown();
        },
        countdownExpired() {
            axios.delete('/backend/logout');
            location.reload();
        },
    },
    created() {
        this.startIdleCountdown();
    },
};
</script>
<style>
    .timer {
        padding: 0px 10px;
        font-size: 12px;
    }
</style>
